<template>
  <footer class="text-dark py-4" style="background-color: #ffc600">
    <b-container>
      <!-- contact -->
      <slot></slot>
      <!-- contact -->

      <!-- contact -->
      <!-- icon -->
      <div class="d-flex align-items-center my-3">
        <hr class="flex-grow-1" />
        <p class="text-nowarp mb-0 mx-3">點擊以下圖標即可聯絡我們</p>
        <hr class="flex-grow-1" />
      </div>
      <div
        class="d-flex flex-column flex-md-row justify-content-center align-content-center"
      >
        <a :href="facebook" target="_blank" class="mx-3">
          <b-icon icon="facebook"></b-icon> Facebook專頁
        </a>
        <a :href="instagram" target="_blank" class="mx-3">
          <b-icon icon="instagram"></b-icon> Instagram專頁
        </a>
        <a :href="youtube" target="_blank" class="mx-3">
          <b-icon icon="youtube"></b-icon> Youtube頻道
        </a>
        <a :href="'tel:+852' + phone" class="mx-3">
          <i class="fas fa-phone"></i> 顧客服務熱線: {{ phone }}
        </a>
        <a :href="'https://wa.me/852' + whatsapp" target="_blank" class="mx-3">
          <i class="fa-brands fa-square-whatsapp"></i> WhatsApp:
          {{ whatsapp }}
        </a>
        <a :href="whatsapp_channel" target="_blank" class="mx-3">
          <b-icon icon="whatsapp"></b-icon> Forever 永恆生活產品香港資訊頻道
        </a>
        <a :href="'mailto:' + email" target="_blank" class="mx-3">
          <i class="fa-solid fa-envelope"></i> {{ email }}
        </a>
      </div>
      <!-- icon -->
      <!-- contact -->

      <!-- copyright -->
      <div class="text-center text- small mt-3">
        @{{ year }} 永恆生活產品亞洲有限公司 FOREVER LIVING PRODUCTS ASIA LTD.
        版權所有
      </div>
      <!-- copyright -->
    </b-container>
  </footer>
</template>

<script setup>
import api from "@/api/index.js";
import { ref, onMounted, computed } from "vue";

const whatsapp = ref([null]);
const whatsapp_channel = ref([null]);
const facebook = ref([null]);
const instagram = ref([null]);
const youtube = ref([null]);
const wechat = ref([null]);
const email = ref([null]);
const phone = ref([null]);
const year = computed(() => {
  return new Date().getFullYear();
});

onMounted(async () => {
  let response = await api.get("/api/get_shop_contact_info");
  response.data.forEach((data) => {
    switch (data.contact_type) {
      case "whatsapp":
        whatsapp.value = data.value;
        break;
      case "whatsappchannel":
        whatsapp_channel.value = data.value;
        break;
      case "facebook":
        facebook.value = data.value;
        break;
      case "instagram":
        instagram.value = data.value;
        break;
      case "youtube":
        youtube.value = data.value;
        break;
      case "wechat":
        wechat.value = data.value;
        break;
      case "email":
        email.value = data.value;
        break;
      case "phone":
        if (data.shop == "永恆生活產品亞洲有限公司 尖沙咀營運中心") {
          phone.value = data.value;
        }
    }
  });
});
</script>

<style scoped>
a {
  text-decoration: none;
  color: #333;
}
a .i {
  text-decoration: none;
  color: #333;
}
.d-flex {
  flex-wrap: wrap;
  min-width: 100%;
}
</style>
